module.exports = __webpack_public_path__ + "img/user-1.ffd29450.jpg";